// WebsiteAd.js

import { housetype } from '../app_const';
import BaseAddressInfo from './BaseAddressInfo';
import WebsiteAdChild from './WebsiteAdChild';


export default class WebsiteAd {
    constructor(data = {}) {
        this.newarcHomeId = data.newarcHomeId || '';
        this.isArchived = data.isArchived ?? false;
        this.isActive = data.isActive ?? true;
        this.publicationDate = data.publicationDate || 0;
        this.lastPublicationDate = data.lastPublicationDate || 0;
        this.title = data.title || '';
        this.type = data.type || '';
        this.floorArea = data.floorArea || 0.0;
        this.roomCount = data.roomCount || 0.0;
        this.baths = data.baths || 0.0;
        this.floors = data.floors || '';
        this.price = data.price || 0.0;
        this.projectType = data.projectType || '';
        this.status = data.status || '';
        this.agencyId = data.agencyId || '';
        this.agencyLogoImage = data.agencyLogoImage || '';
        this.images = Array.isArray(data.images) ? data.images : [];
        // Blur-up placeholders, index-aligned with images (see cloud-functions #142).
        this.imageBlurhashes = Array.isArray(data.imageBlurhashes) ? data.imageBlurhashes : [];

        this.addressInfo = new BaseAddressInfo(data.addressInfo); // You may define a separate class for this
        this.children = Array.isArray(data.children)
        ? data.children.map(child => new WebsiteAdChild(child))
        : [];

        this.publicStatus = data.publicStatus || {};
        this.displayStatus = 1;
        this.zone = data.zone || '';

        let publicStatusTagsUnsorted = data.publicStatus;
        const filtered = Object.entries(publicStatusTagsUnsorted)
            .filter(([, value]) => value === true)
            .map(([key]) => key);

        const novitaIndex = filtered.indexOf("Novità!");
        if (novitaIndex > -1) {
            filtered.splice(novitaIndex, 1); // remove from current position
            filtered.unshift("Novità!");     // add to the beginning
        }

        var hasProjectNewarcTag = false;
        const projectNewarcIndex = filtered.indexOf("Progetto Newarc");

        var hasPartnerVerificationTag = false;
        const projectPartnerVerificationIndex = filtered.indexOf("Partner verificato");
          
        if (projectNewarcIndex > -1) {
            filtered.splice(projectNewarcIndex, 1); // remove from current position
            hasProjectNewarcTag = true
            // filtered.unshift("Novità!");     // add to the beginning
        }

        if (projectPartnerVerificationIndex > -1) {
            filtered.splice(projectPartnerVerificationIndex, 1); // remove from current position
            hasPartnerVerificationTag = true
            // filtered.unshift("Novità!");     // add to the beginning
        }

        this.publicStatus = filtered;
        this.hasProjectNewarcTag = hasProjectNewarcTag;
        this.hasPartnerVerificationTag = hasPartnerVerificationTag;

        let features = {
            'square-meters': this.floorArea +' mq',
            'rooms': this.roomCount.toString() + " locali",
            'bathrooms': this.baths + ' bagni'
        };

        this.features = features;

        // Real property characteristics (array of strings such as "Ascensore",
        // "Ampi balconi", "Terrazzo"). `currentFeatures` is the current-state
        // list; `propertyFeatures` is the Immagina/project list — union them.
        const currentFeatures = Array.isArray(data.currentFeatures) ? data.currentFeatures : [];
        const projectFeatures = Array.isArray(data.propertyFeatures) ? data.propertyFeatures : [];
        this.characteristics = Array.from(new Set([...currentFeatures, ...projectFeatures]));
    }

    getDisplayType() {
        return this.projectType == 'Immagina for Professionals' && this.children.length > 0 ? 'multiple' : 'single';
    }

    getProjectStatus() {
        return this.status == '' || this.status == null ? 'Progetto' : this.status;
    }

    getTitle() {
        if( this.getDisplayType() == 'single' ) {
        
            let rooms = '';
            switch ( this.roomCount ) {
                case 1:
                rooms = 'Monolocale'
                break;
                case 2:
                rooms = 'Bilocale'
                break;
                case 3:
                rooms = 'Trilocale'
                break;
                case 4:
                rooms = 'Quadrilocale'
                break;
                default:
                rooms = 'Plurilocale'
                break;
            }
            
            return `${rooms} in ${this.addressInfo.toShortAddress()}`;

        } else {

            let childrenTypes = this.houseTypes();

            for (let typeindex = 0; typeindex < childrenTypes.length; typeindex++) {
                const sigularName = childrenTypes[typeindex];
                const pluralName = housetype[sigularName];
                childrenTypes[typeindex] = pluralName;
            
            }

            if( childrenTypes.length == 1 ) {
                return `${childrenTypes.join('/')} in ${this.addressInfo.toShortAddress()}`;
            } else {
                let lastType = childrenTypes[childrenTypes.length - 1];

                childrenTypes.splice( childrenTypes.length - 1, 1 );
                let rooms = childrenTypes.join(',');
                return `${rooms} e ${lastType} in ${this.addressInfo.toShortAddress()}`;
            }
        
        }
    }

    /* toFullAddress() {
        const { streetName, streetNumber, locality, city, province, country } = this.addressInfo || {};
        return [streetName, streetNumber, locality ?? city , province, country].filter(Boolean).join(', ');
    }

    toShortAddress() {
        const { streetName, streetNumber, city } = this.addressInfo || {};
        return [streetName, streetNumber, city].filter(Boolean).join(', ');
    } */

    getPrice() {
        if( this.getDisplayType() == 'multiple' ) {
            let minPrice = 0;
            for (let index = 0; index < this.children.length; index++) {
                
                const websiteAdChild = new WebsiteAdChild(this.children[index]);
                let childOriginalPrice = websiteAdChild.price;
                minPrice = childOriginalPrice < minPrice || minPrice == 0 ? childOriginalPrice : minPrice;
                
            }

            return minPrice;
        } else {
            return this.price;
        }
        
    }

    getFormattedPrice() {
        
        return parseInt(this.getPrice()).toLocaleString() + '€';
        
        
    }

    maxPrice() {
        let maxPrice = 0;
        for (let index = 0; index < this.children.length; index++) {
            
            const websiteAdChild = new WebsiteAdChild(this.children[index]);
            let childOriginalPrice = websiteAdChild.price;
            maxPrice = childOriginalPrice > maxPrice ? childOriginalPrice : maxPrice;
        }

        return maxPrice;
    }

    houseTypes() {
        
        var childrenTypes = [];
        for (let index = 0; index < this.children.length; index++) {
            if (!childrenTypes.includes(this.children[index]['type'])) {
                childrenTypes.push(this.children[index]['type']);
            }
        }

        return childrenTypes;
    }


}
